import { FILE_DOWNLOAD_URL } from '@/constant/apiList';
import { DownLoadResponse } from '@/types/api';
import { getNestedDataFetcher } from '@/utils/apis';

/**
 * uuid → 다운로드 URL 단발 조회 (명령형).
 *
 * 같은 엔드포인트를 SWR 로 감싼 `hooks/approval/useDownloadUrl` 은 렌더 중 구독용이라
 * "버튼을 눌렀을 때 한 번만" 같은 흐름(예: 품의 상신 시퀀스)에는 쓸 수 없다.
 * fetcher 는 훅과 동일한 getNestedDataFetcher 를 그대로 쓴다.
 *
 * url 이 비어 온 응답은 성공으로 보지 않는다 — 호출부가 빈 링크를 결재 문서에
 * 실어 보내는 것보다 실패로 끊는 편이 안전하다.
 */
export const fetchDownloadUrl = async (
  uuid: string,
  signal?: AbortSignal,
): Promise<DownLoadResponse> => {
  const res = await getNestedDataFetcher<DownLoadResponse>(
    `${FILE_DOWNLOAD_URL}?uuid=${encodeURIComponent(uuid)}`,
    undefined,
    undefined,
    undefined,
    signal,
  );
  if (!res?.url) {
    throw new Error('다운로드 URL 응답에 url 이 없습니다.');
  }
  return res;
};

export default fetchDownloadUrl;
